module.exports = __webpack_public_path__ + "static/img/list04.088ee1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/list04.jpg
// module id = Lr9N
// module chunks = 1